import { ClientAddress, clientAddressesApi } from "@/lib/api";
import { useAddressBook } from "./useAddressBook";
import { orderShippingAddressesBaseQueryKey } from "./useOrderShippingAddress";

export const clientAddressesQueryKey = (clientId?: number) => ["client-addresses", clientId] as const;

/**
 * Endereços do cliente e as ações sobre eles. Toda alteração invalida também o cliente (`clientQueryKey`), porque
 * mudar o padrão de cobrança atualiza os campos legados de endereço exibidos em "Dados Cadastrais".
 */
export function useClientAddresses(clientId?: number, clientQueryKey?: readonly unknown[]) {
  return useAddressBook<ClientAddress>({
    queryKey: clientAddressesQueryKey(clientId),
    ownerId: clientId,
    api: clientAddressesApi,
    // Endereços de entrega oferecidos na tela de realizar pedido.
    invalidateKeys: [clientQueryKey, orderShippingAddressesBaseQueryKey],
  });
}
